export const filterConfig = [
  {
    id: 'nomeFilial',
    type: 'text',
    label: 'Nome da Filial',
    placeholder: 'Digite o nome da filial',
  },
  {
    id: 'dataCriacaoInicial',
    type: 'date',
    label: 'Data Inicial',
  },
  {
    id: 'dataCriacaoFinal',
    type: 'date',
    label: 'Data Final',
  },
];
